<template>
  <v-container fluid grid-list-md>
    <confirm ref="confirm"></confirm>
       <v-snackbar
            :timeout="3000"
            bottom
            right
            :color="snackbar.color"
            v-model="snackbar.show"
          >
            {{ snackbar.text }}
            <v-btn dark flat @click.native="snackbar.show = false" icon> 
              <v-icon>close</v-icon>
            </v-btn>
          </v-snackbar>  
    <v-dialog v-model="dialogDetalleCM" max-width="700px">
        <v-card>
       
          <v-card-title>
            <span class="title">Detalle Precio - Proveedor</span>
          </v-card-title>
          <v-card-text>
            Rut Proveedor :  <span  class="font-italic caption"> {{ this.detallePrecioCM.rutProveedor }}</span>
            <br>
              Razon Social :  <span  class="font-italic caption"> {{ this.detallePrecioCM.razonSocial }}</span>
            <br>
             Duracion Oferta :  <span  class="font-italic caption"> {{ this.detallePrecioCM.duracionOferta }}</span>
            <br>
             Precio Oferta :  <span  class="font-italic caption"> {{ this.detallePrecioCM.precioOferta }}</span>
            <br>
             Precio Sin Oferta :  <span  class="font-italic caption"> {{ this.detallePrecioCM.precioSinOferta }}</span>
            <br>
             Descuento :  <span  class="font-italic caption"> {{ this.detallePrecioCM.descuento }}</span>
            <br>
             Región:  <span  class="font-italic caption"> {{ this.detallePrecioCM.region }}</span>

             <!-- 

  
            public float? PrecioBase { get; set; }
        public float? CostoDistribucion { get; set; }
        public float? FactorGananciaBase { get; set; }
         

            
             <br>
             PrecioBase:  <span  class="font-italic caption"> {{ this.detallePrecioCM.precioBase }}</span>
              <br>
             CostoDistribucion:  <span  class="font-italic caption"> {{ this.detallePrecioCM.costoDistribucion }}</span>
              <br>
             FactorGananciaBase:  <span  class="font-italic caption"> {{ this.detallePrecioCM.factorGananciaBase }}</span> -->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" flat @click="cleanDetallePreciosCM">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
       
      <v-dialog v-model="dialogHistorialCM" max-width="1100px"  @input="v => v || cleanHistorialDetallePreciosCM()">
        <v-card>
          
          <v-card-title>
             <h3 class="mb-0">Historial Detalle Precio Producto ID: 
              <v-btn
              color="green"
              small               
               style="font-size:14px;"
              slot="activator"
              flat
               @click="verExterno(this.tempLinkProducto)"
            >
              {{ this.tempidProducto }} &nbsp; <v-icon>directions</v-icon> 
            </v-btn>
            </h3>             
          </v-card-title>
          
               <line-chart v-if="graphHistorialCM" chart-id="line-historial" :chart-data="dataHistorial"  :chart-labels="labelsHistorial"  :chart-detail="dataComplementaria" :options="{responsive: true, maintainAspectRatio: false}" /> 
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" flat @click="cleanHistorialDetallePreciosCM">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

       <v-dialog v-model="dialogUploadCM" max-width="1100px"  @input="v => v || verCargaFactores()">
        <v-card>
          
          <v-card-title>
             <h3 class="mb-0">Cargar factores precios Convenio Marco
             
            </h3>             
          </v-card-title>
          <v-card-text>
             <v-flex sm10>
            <v-btn round color="success" class="white--text mb-3" @click="getCMFactoresExcel" v-if="tieneDatos">
               <v-icon>attach_file</v-icon>
              Descargar Configuración Vigente</v-btn>
        
            </v-flex>
           <v-flex sm10>
            <v-text-field label="Adjuntar Archivo" @click="pickFile" v-model="archivo" prepend-icon="attach_file" :readonly="true"></v-text-field>
            <input type="file" style="display: none" ref="image" @change="onFilePicked" id="filePDF"  
            >            
            </v-flex>
            
              </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
             <v-btn color="green" flat @click="guardarFactoresExcel">Guardar</v-btn>
            <v-btn color="grey" flat @click="verCargaFactores">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-layout row wrap>
        <v-flex sm2 >
        <v-btn round color="success" class="white--text mb-3" @click="exportarFiltros" v-if="tieneDatos">
               <v-icon>attach_file</v-icon>
              Exportar Reporte CM</v-btn>
        </v-flex>
        <v-flex sm4 >
        <v-btn round color="success" class="white--text mb-3" @click="verCargaFactores" v-if="tieneDatos">
               <v-icon>attach_file</v-icon>
              Cargar Factores CM</v-btn>
        </v-flex>
          <v-flex sm6>
      <v-spacer></v-spacer>
       <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar..."
              :clearable="false"
              single-line
              hide-details
               @change="getAllByCliente()"
               
            ></v-text-field>
          </v-flex>
          
           
      </v-layout>
    <v-data-iterator
    :items="items"    
            :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        :total-items="totalItems"
        :loading="loading"
        row
        wrap
        no-results-text
        no-data-text
        rows-per-page-text="Registros por página"  
        content-tag="v-layout"
       


      
    >
     
      <template v-slot:item="props">
        <v-flex xs12 sm12 offset-xs1 md4> <!--md4 lg3> -->
     
      <v-card>     
        <v-card-title primary-title>
          <div>
            <h3 class="mb-0">Producto ID: 
              <v-btn
              color="green"
              small               
               style="font-size:14px;"
              slot="activator"
              flat
               @click="verExterno(props.item.link)"
            >
              {{ props.item.idProducto }} &nbsp; <v-icon>directions</v-icon> 
            </v-btn>
            
            </h3>             
            <v-card color="blue lighten-1" class="white--text mt-0">
              <v-card-title primary-title>
                
                <div>Fecha lectura:  {{ new Date(props.item.detallePrecios[0].fechaLectura).toLocaleString() }}</div>
                <div>Nombre: {{ props.item.nombre }}</div>
              </v-card-title>
               
            </v-card>
            <br>
           
            <table>
               <tr>
                  <th></th><th style="text-align: left;">Mejor Precio</th><th style="text-align: left;">Proveedor</th><th style="text-align: right;">&nbsp;</th>
                 </tr> 
             

          
                 <tr  v-for="(item,index) in props.item.detallePrecios"
          :key="index">
                  <td>                    
                        <v-icon left large color="green lighten-1" v-if="item.orden === 1" >fiber_manual_record</v-icon> 
                        <v-icon left large color="yellow lighten-1" v-if="item.orden === 2">fiber_manual_record</v-icon>
                        <v-icon left large color="red lighten-1" v-if="item.orden === 3">fiber_manual_record</v-icon>                   
                    
                    </td>
                    <td style="width:120px;">
                       
                      {{ item.precioOferta }} 
                      
                      
                      </td>
                      <td>
             
                      {{ item.razonSocial }}

              
                        
                        </td>
                        <td>
                <v-btn icon small flat class="ml-0 pl-0 mr-0" v-on="on" color="green"  @click="verDetallePrecioCM(item, props.item.factores)">
                    <v-icon>search</v-icon>
                  </v-btn>
            

                        </td>
                 </tr> 
           




         
          
          
            
           </table>
          
            
          </div>
        </v-card-title>

        <v-card-actions>
          <v-flex sm6>  <v-btn flat color="orange" @click="verDetalleHistorialPrecioCM(props.item)">Ver historial producto</v-btn>  </v-flex>
            <!--<v-flex sm6>  <v-btn
              color="green"    
              flat 
               @click="verExterno('http://www.mercadopublico.cl/TiendaFicha/Ficha?idProducto='+props.item.idProducto)"
            >
              Configurar Factores &nbsp; <v-icon>attach_money</v-icon> 
            </v-btn>      </v-flex>-->
           
        </v-card-actions>
      </v-card>
        </v-flex>
      </template>
     <template
        slot="pageText"
        slot-scope="props"
      >Registros {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
       
    </v-data-iterator>
    <loader :value="loading" message="Cargando productos" progressColor="blue"></loader>
  </v-container>
</template>

<script>
 
import FileService from '@/services/FileService';
import CMService from "@/services/CMService";
import Loader from "@/components/Loader";
import EventBus from "@/eventBus";
import LineChart from '@/components/linecmprecios';
export default {
  components: {
    Loader,
    LineChart
     
  },
  data: () => ({    
      snackbar: {
      show: false,
      text: '',
      color: '',
    },
    dialogUploadCM: false,    
    archivo: "",
     imageName: '',
    imageUrl: '',
    imageFile: '',
    dialogDetalleCM: false,
    dialogHistorialCM: false,
    graphHistorialCM: false,
    tieneDatos: false,
    dataHistorial: [],
    labelsHistorial: [],
    dataComplementaria: [],
    tempidProducto: "",
    tempLinkProducto: "",
    active: null,   
    dialogEditor: false,
    dialogEditorExcluir: false,
    dialogEditorDetalle: false,
    dialogEditorCabecera: false,
    detalleFiltroItems: [],
    loading: true,
    search: '',
    valid: false,
    rules: {
      required: value => !!value || "campo obligatorio.",
      largoNombre: v => !v || v.length <= 50 || "Max 50 carácteres",
      largo: v => !v || v.length <= 300 || "Max 300 carácteres",
      filtro: value => {
        //const pattern = /[^a-zA-Z0-9\s\\*\(\)\|]+/;
        const pattern = /[a-zA-Z0-9*"\s]$/; ///[a-zA-Z0-9!@#$%^*_|]/;
        if (!value || value.trim().length > 0) {
          return pattern.test(value) || "filtro con formato incorrecto.";
        }
      }
    },
    headers: [
      {
        text: "IdProducto",
        align: "left",
        sortable: false,
        value: "idProducto",
        width: "90%"
      },
      {
        text: "Acciones",
        sortable: false
      }
    ],
    itemsLineas: [],
    desserts2: [],
    formTitle: "Editar algo",
    expand: true,
    dialog: false,
    valid: false,
    rowsPerPageItems: [20, 50, 100],
    pagination: {
      page: 1,
      rowsPerPage: 20,
      sortBy: "idProducto",
      descending: true
    },
    detalleEdicion: {
      titulo: "Buscar en cabecera",
      color: "green",
      tipo: 0,
      id: 0,
      idLinea: 0,
      LineaFiltro: "",
      NombreFiltro: ""
    },
    totalItems: 0,
    items: [],
    detallePrecioCM :{
        rutProveedor: "",
        razonSocial: "",
        duracionOferta: "",
        precioOferta: "",
        precioSinOferta: "",
        descuento: "",
        region: "",
        precioBase: 0.00,
        costoDistribucion: 0.00,
        factorGananciaBase: 0.00
        /*
            public float? PrecioBase { get; set; }
        public float? CostoDistribucion { get; set; }
        public float? FactorGananciaBase { get; set; }
        */
    },
  }),
  methods: {
    checkSearch()
    {
      var busqueda = this.search == null ? "" : this.search;
      if(busqueda === "")
      {
       // this.getAllByCliente();
      }
    },
    guardarFactoresExcel()
    {
       let input = document.getElementById('filePDF');
          let files = input.files;
          var FileServiceTMp = new FileService();
          // eslint-disable-next-line
            debugger;
          if (files != null && files.length > 0) {
            FileServiceTMp
              .get(files[0])
              .then(file => {
                this.loading = true;
                debugger;
                CMService
                  .createCMFactoresExcel({
                    File: file ,
                    Model: 'FileUpload'
                  })
                  .then(r2 => {
                    this.loading = false;
                    this.verCargaFactores();
                    this.snackbar = {
                      show: true,
                      color: 'green',
                      text: 'Factores actualizados con éxito',
                      timeout: 3000
                    };
                     
                 
                  })
                  .catch(r2 => {
                    this.loading = false;
                    console.log(r2);
                     this.snackbar = {
                      show: true,
                      color: 'red',
                      text: 'El archivo no cumple con el formato correcto',
                      timeout: 3000
                    };
                  });
              })
              .catch(r1 => {
                console.log(r1);
              });

          }
    },

    verCargaFactores()
    {
      this.removeFile ();
      this.dialogUploadCM = !this.dialogUploadCM;

    },
    removeFile ()
    {
      document.getElementById('filePDF').value = ''; 
      this.archivo = '';
    },
    openFileDialog () {
      document.getElementById('file-upload').click();
    },
    onFileChange (e) {
      let self = this;
      let files = e.target.files || e.dataTransfer.files;       
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          self.formData.append('file', files[i], files[i].name);
        }
      }   
    },
    pickFile () {
      this.$refs.image.click();
    },
    onFilePicked (e) {
      // eslint-disable-next-line
      debugger;
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.archivo = files[0].name;
        if (this.archivo.lastIndexOf('.') <= 0) {
          return;
        }
        
      } else {
        this.archivo = '';
        this.imageFile = '';
        this.imageUrl = '';
      }
    },
    verDetallePrecioCM(item, factores)
    {
        debugger;
      this.detallePrecioCM.rutProveedor = item.rutProveedor;
      this.detallePrecioCM.razonSocial = item.razonSocial;
      
      this.detallePrecioCM.duracionOferta = item.duracionOferta;
      this.detallePrecioCM.precioOferta = item.precioOferta;
      this.detallePrecioCM.precioSinOferta = item.precioSinOferta;
      this.detallePrecioCM.descuento = item.descuento;
      this.detallePrecioCM.region = item.region;     
      this.detallePrecioCM.precioBase = factores.precioBase;      
      this.detallePrecioCM.costoDistribucion = factores.costoDistribucion; 
      this.detallePrecioCM.factorGananciaBase = factores.factorGananciaBase;  
      this.dialogDetalleCM = true;

        
        
    },
     async verDetalleHistorialPrecioCM(item)
    { 
        
         this.loading = true;
      const response = await CMService.getEvolucionProductoCliente(item.id).then(response => {
         
          let data = response.data;
         

          var arrFechas = [];
          var arrHistorial = [];
            data.datos.forEach(function(childSnapshot) {
              arrFechas.push(childSnapshot.fechaLectura); 
              arrHistorial.push(childSnapshot.precioValor);             
            });              
            this.tempidProducto = item.idProducto;
            this.tempLinkProducto = item.link;
            this.dataHistorial = arrHistorial;
            this.labelsHistorial = arrFechas;  
            this.dataComplementaria = data.datos;
            this.loading = false;
            this.dialogHistorialCM = true;
            this.graphHistorialCM = true;
        })
        .catch(r => {
          this.loading = false;
          console.log(r.response);
        });;
       
      
    
    },
    cleanDetallePreciosCM()
    {
      this.dialogDetalleCM = false;
      this.detallePrecioCM.rutProveedor ="";
      this.detallePrecioCM.razonSocial ="";
     
      this.detallePrecioCM.duracionOferta ="";
      this.detallePrecioCM.precioOferta ="";
      this.detallePrecioCM.precioSinOferta ="";
      this.detallePrecioCM.descuento  ="";
      this.detallePrecioCM.region ="";     
    },
    cleanHistorialDetallePreciosCM()
    {
        
        this.dataHistorial = [];
        this.labelsHistorial = [];    
        this.dataComplementaria = [];
         this.tempidProducto = "";
         this.tempLinkProducto = "";
         this.dialogHistorialCM = false;
        this.graphHistorialCM = false;
    },
     verExterno(link) {
      window.open(link, "_blank");
    },
    actualizarDataFiltros: function() {
      this.getAllByCliente();
    },
    
          
    async exportarFiltros() {      

        this.loading = true;        
        const response = await CMService.avisosProductosCMExcel(
        );
        this.loading = false;
     
    },
     async getCMFactoresExcel() {      

        this.loading = true;        
        const response = await CMService.getCMFactoresExcel(
        );
        this.loading = false;
     
    }, 
    async getAllByCliente() {
      this.loading = true;
      var cliente = localStorage.getItem("clienteid"); //this.clienteid;
      let paging = this.pagination;
      let sort = paging.sortBy === null ? "id" : paging.sortBy;
      let direction =
        paging.descending === null
          ? " desc"
          : paging.descending === true
          ? " desc"
          : " asc";
      sort = sort + direction;
      let paginacion =
        "sort=" +
        sort +
        "&page=" +
        paging.page +
        "&pageSize=" +
        paging.rowsPerPage;
  
   var busqueda = this.search == null ? "" : this.search;
      
      const response = await CMService.getProductosCMClienteOptimizado( paginacion,
        busqueda)
        .then(r => {
          debugger;
          this.items = r.data.data;
          this.totalItems = r.data.totalCount;
          if(r.data.totalCount > 0)
          {
            this.tieneDatos = true;
          }
          else{
            this.tieneDatos = false;
          }
          this.loading = false;
        })
        .catch(r => {
           this.loading = false;
          console.log(r.response);
        });
    }
  },
  watch: {
   pagination: {
      handler() {
        this.getAllByCliente();
      },
      deep: true
    },
    dialogEditorCabecera: {
      handler: function(val, oldVal) {
        if (!val) {
          this.actualizarDataFiltros();
          setTimeout(function() {
            //this.getAllByCliente();
            this.active = 0;
          }, 500);
        }
      },
      deep: true
    },
    dialogEditor: {
      handler: function(val, oldVal) {
        if (!val) {
          this.actualizarDataFiltros();
          setTimeout(function() {
            this.active = 0;
            //this.getAllByCliente();
          }, 500);
        }
      },
      deep: true
    },
    dialog: {
      handler: function(val, oldVal) {
        if (!val) {
          this.actualizarDataFiltros();
          setTimeout(function() {
            this.active = 0;
            //this.getAllByCliente();
          }, 500);
        }
      },
      deep: true
    }
  },
  computed: {
     verEditor(){
      
      var verEditor = localStorage.getItem('rol');
      return (verEditor!="Ejecutivo");

    },
    usuario() {
      var usuario = this.$store.getters.currentUser;
      if (!usuario) {
        return "";
      } else {
        return usuario;
      }
    },
    clienteid() {
      var clienteid = localStorage.getItem("clienteid"); //this.$store.getters.currentClienteId;
      if (!clienteid) {
        return "";
      } else {
        return clienteid;
      }
    },

    form() {
      return {
        id: this.detalleEdicion.idLinea
      };
    },
    form2() {
      return {
        id: this.detalleEdicion.id
      };
    }
  },
  mounted() {
    //const response = this.getAllByCliente();
     this.getAllByCliente();
    EventBus.$on('rebuildFilter', () => {
     this.getAllByCliente();
    })
  },
  created() {
    
        window.getApp = this;
  },
};
</script>
  
 
